import React from 'react';
import './LoadingScreen.css';
import LogoImage from '../../assets/NavbarIcon/logo-image.png';
import { CircularProgress, Box } from '@mui/material';

/**
 * LoadingScreen component
 *
 * Displays the Klass.Online logo centered inside a circular progress bar.
 */
const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="circular-progress-container">
        <CircularProgress
          size={120}
          thickness={2}
          className="circular-progress"
          sx={{ color: '#0068ff' }}
        />
        <div className="logo-container">
          <img className="logo" src={LogoImage} alt="Klass.Online logo" />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
